<template>
    <div class="font-sans antialiased leading-tight p-0 xs:-mr-5 w-full overflow">
        <app-header></app-header>
        <div class="mb-6">
            <div class="bg-grey-lightest">
                <div class="container mx-auto px-6 pt-32">
                    <h1 class="text-center text-black font-semibold text-4xl mb-12">
                        Удаление аккаунта в приложении Lingua AI
                    </h1>
                    <div class="pb-10">
                        <p class="mb-4">Если вы хотите удалить аккаунт из приложения Lingua AI, отправьте свой запрос на почту <a href="mailto:lingua.ai.mobile.app@gmail.com">lingua.ai.mobile.app@gmail.com</a>, в письме укажите свой email который вы использовали при входе в приложение Lingua AI.</p>
                    </div>
                </div>
            </div>
            <svg id="curveDownColor" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100" viewBox="0 0 100 100" preserveAspectRatio="none">
                <path style="fill: #f8fafc;" d="M0 0 C 50 100 80 100 100 0 Z" />
            </svg>
        </div>
        <app-download></app-download>
        <app-footer></app-footer>
    </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import AppFooter from "./components/AppFooter.vue";
import AppDownload from "./components/AppDownload.vue";

export default {
    components: {
        AppHeader,
        AppFooter,
        AppDownload
    }
};
</script>

<style>
@tailwind preflight;
@tailwind components;
@tailwind utilities;
</style>
